module.exports = "mutation BulkDeleteSendableCards($cards: [ID!]!) {\n  bulkDeleteSendableCards(cards: $cards) {\n    successful\n    failedCount\n  }\n}\n"